import React from "react";
import OrdersSidebar from "@widgets/pos/orders/sidebar/ordersSidebar";
import {useParams} from "react-router-dom";
import OrderOverview from "@widgets/pos/orders/details/OrderOverview";


const OrdersOverview = () => {
    const {publicCartId} = useParams();

    return (
        <div className={"h-full grid grid-cols-[440px_1fr] grid-rows-1"}>
            <OrdersSidebar selectedPublicCartId={publicCartId}/>
            <OrderOverview selectedPublicCartId={publicCartId}/>
        </div>
    );
};

export default OrdersOverview;